import { render, staticRenderFns } from "./BotLinkV2.vue?vue&type=template&id=3c3af9f8"
import script from "./BotLinkV2.vue?vue&type=script&lang=js"
export * from "./BotLinkV2.vue?vue&type=script&lang=js"
import style0 from "./BotLinkV2.vue?vue&type=style&index=0&id=3c3af9f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports